import Modal from "components/ui/Modal";
import React, { useEffect, useState } from "react";
import { ReactComponent as MyBinnyLogo } from "assets/catalogSetting/myBinnysLogo.svg";
import ChipSelect from "components/ui/FilterModal/ChipSelect";
import Button from "components/ui/Button";
import { styled } from "@mui/material";
import apiClient from "lib/api-client";
import { getLimits, getMyBinnysClientLimits } from "features/Setting/Limits/api/limitsApis";
import { toast } from "react-toastify";
import { usePermissions } from "context/PermissionsContext";

const CustomButton = styled(Button)(({}) => ({
  width: "61%",
  fontFamily: "Karla",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "22px",
  height: "50px",
  borderRadius: "5px",
  color: "#00000",
  border: `1px solid #ffffff `,
  textTransform: "none",
  backgroundColor: "#50C878",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#50C878",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#444444",
    color: "#000000",
    border: "1px solid #444444",
  },
}));

const ShareToMyBinnysModal = ({ open, handleClose, handleShareDataRef, isLoading, currentCatalogDesigns }) => {
  const [hour, setHour] = useState("");
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientRawList, setClientRawList] = useState([]);

  const permissions = usePermissions();

  // console.log("isLoading--->>",isLoading)

  // ------------------------------------------------------ My Binnys Client Company Names ----------------------------------------------------------------- \\

  useEffect(() => {
    // if (!open) return;

    const fetchClients = async () => {
      try {
        const response = await apiClient.get("/api/v9/myBinnys/myBinnysClientCompanyNames");
        if (response.data?.status === 200) {
          setClientRawList(response.data.data);
          const formattedClients = response.data.data.map((client) => client.clientName);
          setClientOptions(formattedClients);
        }
      } catch (error) {
        console.error("Error fetching client list:", error);
      }
    };

    fetchClients();
  }, []);

  const handleClientChange = (e) => {
    const selected = e?.target?.value;
    setSelectedClients(Array.isArray(selected) ? selected : [selected]);
  };

  const handleDeleteClient = (clientToDelete) => {
    setSelectedClients((prev) => prev.filter((client) => client !== clientToDelete));
  };

  const handleChange = (e) => {
    const val = e.target.value;

    if (val === "") {
      setHour("");
      return;
    }

    if (/^\d{0,2}$/.test(val)) {
      const num = parseInt(val, 10);

      if (!isNaN(num)) {
        if (num < 1) setHour(1);
        else if (num > 72) setHour(72);
        else setHour(num);
      }
    }
  };

  const handleShareClick = async () => {
    if (!hour || selectedClients.length === 0) return;

    //check limit
    const userData = localStorage.getItem("userData");
    const userDataParsed = JSON.parse(userData);
    let data = await getLimits(userDataParsed?._id);
    let hourLimit = data?.exists?.accessTimeLimitHours;

    if (hourLimit < hour && !permissions?.isAdmin) {
      return toast.error(`You can have a maximum of ${hourLimit} hour limit.`);
    }

    //Check My Binnys Client Limit
    let myBinnysCompanyIds = selectedClients
      .map((name) => {
        const found = clientRawList.find((c) => c.clientName === name);
        return found?._id;
      })
      .filter(Boolean);
    let clientData = await getMyBinnysClientLimits(myBinnysCompanyIds);

    //Found Invalid

    let checkClientNotElligible = clientData?.data?.filter((entry) => {
      if (entry.limit < currentCatalogDesigns) return entry;
    });

    if (checkClientNotElligible?.length > 0 && !permissions?.isAdmin) {
      const users = checkClientNotElligible.map((client) => client.companyName).join(", ");

      return toast.error(`Cannot share catalog. Limit not matched for:${users}`);
    }

    const payload = {
      sessionDuration: Number(hour),
      myBinnysCompanyIds: selectedClients
        .map((name) => {
          const found = clientRawList.find((c) => c.clientName === name);
          return found?._id;
        })
        .filter(Boolean),
    };

    handleShareDataRef(payload);
  };

  useEffect(() => {
    if (!open) {
      setHour("");
      setSelectedClients([]);
    }
  }, [open]);

  return (
    <Modal open={open} handleClose={handleClose} style={{ width: "500px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "1vw" }}>
        <div style={{ display: "flex", alignItems: "center", fontFamily: "Poppins", fontWeight: 500, fontSize: "24px", lineHeight: "22px", letterSpacing: "-0.41px", gap: "0.3vw" }}>
          Share to{" "}
          <span>
            <MyBinnyLogo />
          </span>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "0.5vw" }}>
          <p style={{ fontFamily: "Poppins", fontWeight: 400, fontSize: "20px", lineHeight: "22px", letterSpacing: "-0.41px" }}>Client Name</p>
          <ChipSelect
            value={Array.isArray(selectedClients) ? selectedClients : []}
            onChange={handleClientChange}
            options={clientOptions}
            onDelete={handleDeleteClient}
            placeholder={"Select Client"}
            menuStyles={{
              maxHeight: "200px",
              overflowY: "auto",
            }}
            width={"100%"}
          />
        </div>

        <div>
          <p style={{ fontFamily: "Poppins", fontWeight: 400, fontSize: "20px", lineHeight: "22px", letterSpacing: "-0.41px" }}>Hours</p>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6vw" }}>
            <input type="text" value={hour} placeholder="HH" className="centered-input" onChange={handleChange} />
            <style>
              {`
                                .centered-input {
                                    width: 50px;
                                    height: 50px;
                                    border-radius: 0.25vw;
                                    border: 1px solid #000;
                                    text-align: center;
                                    outline: none;
                                    font-size: 18px;
                                    font-family: 'karla';
                                }
                                .centered-input:focus {
                                    outline: none;
                                }
 
                                .centered-input::placeholder {
                                    color: #8B8B8B;
                                    text-align: center;
                                }
                            `}
            </style>
            <p style={{ fontFamily: "Karla", fontWeight: 400, fontSize: "12px", lineHeight: "22px", letterSpacing: "-0.41px" }}>Between 1 To 72 Hours</p>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "1vw" }}>
        <CustomButton variant="contained" onClick={handleShareClick} disabled={hour === "" || selectedClients.length === 0 || isLoading}>
          {isLoading ? "Sharing..." : "Share Catalog"}
        </CustomButton>
      </div>
    </Modal>
  );
};

export default ShareToMyBinnysModal;
